export default class TokenClaims {
  constructor(
    public personId: string,
    public teamIds: string[],
    public coachedTeamIds: string[]
  ) {}
}